
/*
    * Type Scripts Methods And Events
*/
import Vue from "vue";
import * as _ from 'lodash';
import VueRouter from "vue-router";
import Axios from 'axios';
import About from './../components/App/Assets/About/About.vue';
import { Component } from "vue-property-decorator";
import { App } from "./../store/modules/App/types";
import EditProfile from './../components/App/Assets/EditProfile/EditProfile.vue';
import Announcement from './../components/App/Assets/Announcement/Announcement.vue';
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Utilities } from './../shared/utilities';
import { State, Action, Getter } from "vuex-class";
import { http } from '@/shared/https';
import { Workspace } from '@/entities';
import SwitchLanguage from '@/components/App/Assets/Language/SwitchLanguage.vue';
import AuthService from "@/services/auth.service";
import { AppConstants as _app } from '@/shared/app.constants';
import { User } from "oidc-client";
const auth = new AuthService();

const namespace: string = "RootApp";
const defaut_layout: string = "default";
const roles = _app.roles;

/*
    * Component's properties and events
*/
@Component({
    components: {
        About,
        EditProfile,
        Announcement,
        Dashboard,
        DashLayout,
        DashItem,
        SwitchLanguage
    }
})

export default class PublicComponent extends Vue {
    @State("RootApp") app!: App;
    @State("application") application!: Workspace;
    @Action("_appBtnClick", { namespace }) _appBtnClick: any;
    @Action("_appTabClick", { namespace }) _appTabClick: any;
    @Action("_appTileClick", { namespace }) _appTileClick: any;
    @Action("_appAbout", { namespace }) _appAbout: any;
    @Action("_appErrorLog", { namespace }) _appErrorLog: any;
    @Action("_getModuleGroup", { namespace }) _getModuleGroup: any;
    @Getter("renderComponent", { namespace: "dashboard" })
    renderComponents: any;
    @Getter("removeComponent", { namespace: "dashboard" })
    removeComponent: any;
    homePage:string = "/";
    show=false;
    adminModuleAllowedRoles=[_app.appRoles.SuperAdmin,_app.appRoles.SystemAdmin,_app.appRoles.ProgramAdmin,_app.appRoles.InitiativeAdmin,_app.appRoles.MEAdmin]

    get layout() {
        return (this.$route.meta.layout || 'defaut_layout') + '-layout';
    }

    get settings() {
        // @ts-ignore
        this.$store.state.dashboard.tabs = this.$store.state.RootApp.menu.tabs;
        // @ts-ignore
        this.$store.state.dashboard.openNodes = this.$store.state.RootApp.menu.openNodes;
        // @ts-ignore
        this.$store.state.dashboard.tree = this.$store.state.RootApp.menu.tree;
        // @ts-ignore
        this.$store.state.dashboard.profileClose = this.$store.state.RootApp.profileClose;
        // @ts-ignore
        this.$store.state.dashboard.profileClosePath = this.$store.state.RootApp.profileClosePath;
        return this.$store.state.dashboard;
      }

    /*
        * The mounted() method gives you access to templates and enables interaction with the DOM.
    */
    mounted() {
        //#.Current Context
        let context = this.$store.state.RootApp, crumbs, self = this, lang = localStorage.getItem('locale');
            auth.isLoggedIn().then((isLoggedIn: boolean) => {
                  if (isLoggedIn) {
                    auth.getUser().then((user: User) => {
                          auth.isLoggedIn().then((isLoggedIn: boolean) => {
                  if (isLoggedIn) {
                    auth.getUser().then((user: User) => {
                      let userRoles=[]
                      if (Array.isArray(user.profile.role_id)) {
                        userRoles = userRoles.concat(user.profile.role_id);
                      } 
                      else {
                        userRoles.push(user.profile.role_id);
                      }
                      userRoles.forEach(id=>
                      {
                          if(this.adminModuleAllowedRoles.includes(String(id)))
                          {
                            this.show=true
                          }
                          else
                          {
                          }
                      })
                    })
                  }
                })
             });
        }
        })
        //#.Button tooltip translator
        if (context.buttons) {
            _.forOwn(context.buttons.btn, function (key, val) {
                if (key.tooltip) {
                    key.tooltip = self.$t(key.tooltip) || key.tooltip;
                }
            });

            context.about.copyRight = self.$t(context.about.copyRight) || context.about.copyRight;
            context.about.title = self.$t(context.about.title) || context.about.title;
        }

        if (lang != null && lang != "" && lang != undefined)
            self.$vuetify.lang.current = lang;

        //#.Get location storage information 
        context.menu.cacheMenus.tabs = localStorage.getItem('vueAppMenuTab');
        context.menu.cacheMenus.module = localStorage.getItem('vueAppModule');
        crumbs = localStorage.getItem('breadcrumbs');

        if (crumbs != null && crumbs != "")
            context.breadcrumbs.list = JSON.parse(crumbs);

        //#.Set location storage information in app state
        if (context.menu.cacheMenus.tabs != '' && context.menu.cacheMenus.tabs != null) {
            context.height = '38px !important';
            context.menu.tabs = JSON.parse(context.menu.cacheMenus.tabs);
            context.moduleGroup.name = JSON.parse(context.menu.cacheMenus.module).name;
            context.moduleGroup.icon = JSON.parse(context.menu.cacheMenus.module).icon;
            context.moduleGroup.color = JSON.parse(context.menu.cacheMenus.module).color;
            context.moduleGroup.container = false;
            context.breadcrumbs.enabled = true;
        }

        //#.Checking home page or screen
        if (window.controller && window.area) {
            context.moduleGroup.container = false;
        }

        auth.isLoggedIn().then((isLoggedIn) => {
            if (isLoggedIn) {
                this.homePage = "/dashboard";
                
                return http.get(context.actions.list).then(record => {
                    _app.region.default = record.data.Locale;
                    _app.region.decimalSeparator = record.data.DecimalSeparator;
                    _app.currency.symbol = record.data.CurrencySymbol;
                    _app.region.CurrencyGroupSeparator = record.data.CurrencyGroupSeparator;
                    try {
                        this._getModuleGroup({
                            moduleGroups: record.data.modulGrp,
                            menuList: record.data.menu,
                            location: record.data.accountingLocation,
                            modules: record.data.modules,
                            avatar: record.data.Avatar });

                        if (record.data.announcementCount > 0) {
                            let count = record.data.announcementCount;

                            _.forOwn(context.buttons.btn, function (key, val) {
                                if (key.name == 'announce') {
                                    key.count = count;
                                }
                            });
                        }
                    } catch (error) {
                        this._appErrorLog({ error: 'app > _getModuleGroup > ' + error.message });
                    }
                }).catch(error => {
                    this._appErrorLog({ error: context.actions.list + ' > ' + error.message });
                });
            }
        });
    }

    /** back to home page on logo click */
    backToHome() {
        this.$router.push({
            name: "dashboard",
            query: {}
        });
    }

    /*
       * Translate menu type
    */
    translate(menuType) {
        let self = this;

        _.forOwn(menuType, function (key, val) {
            if (key) {
                key = self.$t(key) || key;
            }
        });
    }

    /*
       * Search application menus
    */
    _appSearchMenu(menu) {
        //#.Current Context
        let context = this.$store.state.RootApp;

        //#.Null checking.
        if (!menu) {
            //#.Getter function
            this.removeComponent;

            context.menu.tabs = [];
            context.moduleGroup.name = '';
            context.moduleGroup.icon = ''
            context.moduleGroup.color = '';
            context.moduleGroup.container = true;
            return;
        }

        //#.Removed tile container in the DOM
        context.moduleGroup.container = false;

        context.moduleGroup.modules.filter(x => x.ModuleName == menu.Module).forEach(key => {
            //#.Current state context
            let payload = context.moduleGroup.list.find(x => x.Id == key.ModuleGroupId);

            if (!payload) {
                return;
            }

            //#.Updated module group, icon and color
            context.moduleGroup.name = payload.Name;
            context.moduleGroup.icon = payload.icon;
            context.moduleGroup.color = payload.Color;
            context.menu.tabs = [];

            //#.Updated menu tabs
            if (!context.moduleGroup.tiles[0]) {
                return
            }

            context.moduleGroup.tiles[0].items.filter(x => x.Name == payload.Name).forEach(key => {
                key.Modules.filter(x => x.ModuleName != null).forEach(key => {
                    if (context.menu.collection.filter(x => x.Module == key.ModuleName).length > 0)
                        context.menu.tabs.push(key.ModuleName);
                });
                if (context.menu.collection.filter(x => x.Module == key.ModuleName).length > 0)
                    context.menu.tabs.push(key.ModuleName);
            });
        });
    }

    /*
        * Router link click event
    */
    _appRouterLink(path) {
        //#.Root context
        // @ts-ignore
        let root = this.$store.state.RootApp;
        // @ts-ignore
        let rootState = this.$store.state;
        // @ts-ignore
        let translate = this.$vuetify.lang;
        root.announcement = false;

        //#.Clear router history and reset history
        root.routers = [];
        root.routers.push(path);
        localStorage.setItem('routers', JSON.stringify(root.routers));

        //#.Remove extraParams in axios.
        localStorage.setItem('extraParams', '');
        // @ts-ignore
        this.$store.state.dashboard.extraParams = null;

        //#.Static methods for fetch menu id
        let menuId = Utilities.getParameterByName('mId');

        //#.Reset breadcrumb 
        this.app.breadcrumbs.list = [];
        this._appGenerateBreadcrumbs(this.app.menu.tree, menuId);
        root.breadcrumbs.enabled = true;

        return http.get(root.actions.getTemplates + menuId).then(record => {
            if (record.data.Result == 'OK') {
                // @ts-ignore
                let payload = this.$store.state.dashboard;
                payload.componentId = 0;

                // @ts-ignore
                payload.security = [];
                payload.template = JSON.parse(record.data.Template);
                payload.cards = record.data.Component;
                payload.title = record.data.Caption;
                payload.tooltip = record.data.Tooltip;
                payload.search = record.data.SearchURL;
                payload.searchComponent = (record.data.SearchName == null ? false : record.data.SearchName);
                payload.breadCrumb = record.data.BreadCrumb;
                payload.close = payload.template.close;
                payload.tabularList = record.data.Tabular;

                //#.Checking enable / disable component close
                if (payload.close) {
                    root.profileClose = true;
                } else {
                    root.profileClose = false;
                }

                //#.Filter component enabled.
                if (payload.template.filter == true) {
                    payload.cards.push("FilterComponent");
                    payload.title.push("Filter");
                }

                //#.Auto fit template enabled.
                if (payload.template.autofit == true) {
                    payload.autoFit = true;
                }

                //#.Tabular form template enabled.
                if (payload.template.tabularform == true) {
                    payload.tabularForm = true;
                }

                //#.Check if the component is mobile app
                if (payload.template.mobileApp == true) {
                    payload.mobileApp = true;
                }

                //#.Apply translation to messages
                if (payload.keyTranslator) {
                    _.forOwn(payload.messages, function (key, val) {

                        if (val.indexOf('_') == -1 && !payload.messages["_" + val])
                            payload.messages["_" + val] = key;

                        if (val.indexOf('_') == -1)
                            payload.messages[val] = translate.locales[translate.current][payload.messages["_" + val]] || payload.messages["_" + val];
                    });
                }

                //#.Update component title
                payload.cards.filter(x => x).forEach(key => {
                    let componentName = key.charAt(0).toLowerCase() + key.slice(1).replace('Component', '');
                    componentName = componentName + 'Index';

                    //#.Index of the components
                    let index = payload.cards.indexOf(key);

                    rootState[componentName].card.multiColumn = rootState[componentName].multiColumn || 'Auto';

                    //#.Checking workflow implementation
                    if (rootState[componentName].fields.WorkFlowStatusId) {
                        rootState[componentName].fields.WorkFlowStatusId.value = rootState[componentName].workflow.workflowStepId;
                        rootState[componentName].fields.Comments.value = rootState[componentName].workflow.workflowComments;
                    }

                    if (!_.includes(payload.title[payload.cards.indexOf(key)], '{{')) {
                        rootState[componentName].title = payload.title[payload.cards.indexOf(key)];

                        //#.Header list
                        let header = [], totalFields, fieldsList = [];
                        rootState[componentName].landscape = true;

                        // @ts-ignore
                        _.forOwn(rootState[componentName].fields, function (key, val) {
                            if (key.primaryKey != true && key.parent != true && key.list != false && key.type != 'Hidden') {

                                if (!key.orgTitle)
                                    key.orgTitle = key.title;

                                if (payload.keyTranslator)
                                    key.text = translate.locales[translate.current][key.orgTitle] || key.orgTitle;
                                else
                                    key.text = key.title;

                                key.title = key.text;
                                // @ts-ignore
                                header.push(key);
                            }

                            if (!key.primaryKey && key.type != 'Hidden' && !key.create && !key.parent) {
                                // @ts-ignore
                                fieldsList.push(key.value);
                            }
                        });

                        rootState[componentName].headers = header;

                        if (rootState[componentName].card.type != rootState[componentName].type._tree) {
                            totalFields = fieldsList.length;

                            //Auto arrange the field layout
                            if (rootState[componentName].multiColumn == 'Auto') {
                                if (totalFields >= 1 && totalFields <= 6) {
                                    rootState[componentName].card.multiColumn = 1;
                                } else if (totalFields >= 7 && totalFields <= 12) {
                                    rootState[componentName].card.multiColumn = 2;
                                } else if (totalFields >= 12 && totalFields <= 18) {
                                    rootState[componentName].card.multiColumn = 3;
                                } else {
                                    rootState[componentName].card.multiColumn = 4;
                                }

                                rootState[componentName].multiColumn = rootState[componentName].card.multiColumn;
                            } else {
                                rootState[componentName].card.multiColumn = rootState[componentName].multiColumn;
                            }

                            if (rootState[componentName].multiColumn > 2) {
                                rootState[componentName].landscape = false;
                            }

                            if (rootState[componentName].inlineEditor.enabled) {
                                rootState[componentName].landscape = false;
                            }
                        }
                    } else {
                        rootState[componentName].titleSearch = true;
                        let title = (payload.title[index]).substr(2).slice(0, -2);
                        rootState[componentName].headerTooltip = rootState[componentName].fields[title].title;
                    }
                });

                payload.renderComponent = false;

                Vue.nextTick(() => {
                    // @ts-ignore
                    payload.renderComponent = true;
                });
            }
        });
    }

    /*
        * Generate breadcrumbs
    */
    _appGenerateBreadcrumbs(menuList, id) {
        //#.Iterate menu list
        for (var i in menuList) {

            if (menuList[i].id == id) {

                let module = {
                    text: menuList[i].Module,
                    disabled: true,
                    href: menuList[i].Module
                }

                //#.Add breadcrub list
                this.app.breadcrumbs.list.push(module);

                if (menuList[i].ParentName && menuList[i].ParentName.split('/').length > 1) {

                    let menuType = {
                        text: menuList[i].ParentName.split('/')[0],
                        disabled: true,
                        href: menuList[i].ParentName.split('/')[0]
                    }

                    //#.Add breadcrub list
                    this.app.breadcrumbs.list.push(menuType);

                    let menuGroup = {
                        text: menuList[i].ParentName.split('/')[1],
                        disabled: true,
                        href: menuList[i].ParentName.split('/')[1]
                    }

                    //#.Add breadcrub list
                    this.app.breadcrumbs.list.push(menuGroup);
                } else {

                    let menuType = {
                        text: menuList[i].ParentName,
                        disabled: true,
                        href: menuList[i].ParentName
                    }

                    //#.Add breadcrub list
                    this.app.breadcrumbs.list.push(menuType);
                }

                let menu = {
                    text: menuList[i].name,
                    href: menuList[i].name,
                    disabled: false
                }

                //#.Add breadcrub list
                this.app.breadcrumbs.list.push(menu);
                return;
            }

            //#.Recursive method.
            if (menuList[i].children.length > 0) {
                this._appGenerateBreadcrumbs(menuList[i].children, id)
            }
        }

        //#.Add breadcrumbs to the local storage
        localStorage.setItem('breadcrumbs', JSON.stringify(this.app.breadcrumbs.list));

        return this.app.breadcrumbs.list;
    }

    /*
        * Enabled tile menu
    */
    _appEnableTilePanel() {
        //#.Getters
        this.removeComponent;

        // @ts-ignore
        this.$store.state.dashboard.renderComponent = false;

        //#.Update url
        history.pushState({
            id: ''
        }, '', location.origin);

        //#.Reset location storage information and root props
        localStorage.setItem('vueAppMenuTab', '');
        localStorage.setItem('vueAppModule', '');
        this.app.height = '0px !important';
        this.app.breadcrumbs.enabled = false;
        this.app.profileClose = false;
        this.app.moduleGroup.container = true;
        this.app.announcement = false;
        this.app.moduleGroup.icon = '';
        this.app.moduleGroup.color = '';
        this.app.moduleGroup.name = '';
        this.app.menu.tabs = [];
    }

    /*
        * Components close event
    */
    _appCloseBtn() {
        //#.Root context
        let root = this.$store.state.RootApp;
        let rootState = this.$store.state;
        let translate = this.$vuetify.lang;

        //#.Checking router history
        if (root.routers.length == 0) {
            //#.Get local storage information
            root.routers = localStorage.getItem('routers');
            if (root.routers != "")
                root.routers = JSON.parse(root.routers);

            localStorage.setItem('routers', '');
        }

        //#.Removing last url path.
        if (root.routers.length != 0) {
            //#.Update router array list.
            delete root.routers[root.routers.length - 1];
            root.routers.length = root.routers.length - 1;
            localStorage.setItem('routers', JSON.stringify(root.routers));

            if (root.routers.length == 1) {
                root.profileClosePath = root.routers[0];
                //#.Update url history
                history.pushState({
                    id: ''
                }, '', root.profileClosePath);
            } else if (root.routers.length != 0) {
                root.profileClosePath = root.routers[root.routers.length - 1];
                //#.Update url history
                history.pushState({
                    id: ''
                }, '', root.profileClosePath);
            }
        }

        //#.Remove extraParams in axios.
        localStorage.setItem('extraParams', '');
        // @ts-ignore
        this.$store.state.dashboard.extraParams = null;

        //#.Static methods for fetch menu id
        let menuId = Utilities.getParameterByName('mId');

        //#.Reset breadcrumbs
        this.app.breadcrumbs.list = [];
        this._appGenerateBreadcrumbs(this.app.menu.tree, menuId);
        root.breadcrumbs.enabled = true;

        return http.get(root.actions.getTemplates + menuId).then(record => {
            if (record.data.Result == 'OK') {
                // @ts-ignore
                let payload = this.$store.state.dashboard;

                //#.Update component id
                if (root.profileClosePath != "") {
                    let path = root.profileClosePath.split('#');

                    if (path.length == 1) {
                        payload.componentId = 0;
                    } else {
                        payload.componentId = path[1];
                    }
                }

                // @ts-ignore
                payload.security = [];
                payload.template = JSON.parse(record.data.Template);
                payload.cards = record.data.Component;
                payload.title = record.data.Caption;
                payload.tooltip = record.data.Tooltip;
                payload.search = record.data.SearchURL;
                payload.searchComponent = (record.data.SearchName == null ? false : record.data.SearchName);
                payload.breadCrumb = record.data.BreadCrumb;
                payload.close = payload.template.close;
                payload.tabularList = record.data.Tabular;

                //#.Checking enable / disable component close
                if (payload.close) {
                    root.profileClose = true;
                } else {
                    root.profileClose = false;
                }

                //#.Auto fit template enabled.
                if (payload.template.autofit == true) {
                    payload.autoFit = true;
                }

                //#.Tabular form template enabled.
                if (payload.template.tabularform == true) {
                    payload.tabularForm = true;
                }

                //#.Check if the component is mobile app
                if (payload.template.mobileApp == true) {
                    payload.mobileApp = true;
                }

                //#.Apply translation to messages
                if (payload.keyTranslator) {
                    _.forOwn(payload.messages, function (key, val) {

                        if (val.indexOf('_') == -1 && !payload.messages["_" + val])
                            payload.messages["_" + val] = key;

                        if (val.indexOf('_') == -1)
                            payload.messages[val] = translate.locales[translate.current][payload.messages["_" + val]] || payload.messages["_" + val];
                    });
                }

                //#.Update component title
                payload.cards.filter(x => x).forEach(key => {
                    let componentName = key.charAt(0).toLowerCase() + key.slice(1).replace('Component', '');
                    componentName = componentName + 'Index';

                    //#.Index of the components
                    let index = payload.cards.indexOf(key);

                    rootState[componentName].card.multiColumn = rootState[componentName].multiColumn || 'Auto';

                    //#.Checking workflow implementation
                    if (rootState[componentName].fields.WorkFlowStatusId) {
                        rootState[componentName].fields.WorkFlowStatusId.value = rootState[componentName].workflow.workflowStepId;
                        rootState[componentName].fields.Comments.value = rootState[componentName].workflow.workflowComments;
                    }

                    if (!_.includes(payload.title[payload.cards.indexOf(key)], '{{')) {
                        rootState[componentName].title = payload.title[payload.cards.indexOf(key)];

                        //#.Header list
                        let header = [], totalFields, fieldsList = [];
                        rootState[componentName].landscape = true;

                        // @ts-ignore
                        _.forOwn(rootState[componentName].fields, function (key, val) {
                            if (key.primaryKey != true && key.parent != true && key.list != false && key.type != 'Hidden') {

                                if (!key.orgTitle)
                                    key.orgTitle = key.title;

                                if (payload.keyTranslator)
                                    key.text = translate.locales[translate.current][key.orgTitle] || key.orgTitle;
                                else
                                    key.text = key.title;

                                key.title = key.text;
                                // @ts-ignore
                                header.push(key);
                            }

                            if (!key.primaryKey && key.type != 'Hidden' && !key.create && !key.parent) {
                                // @ts-ignore
                                fieldsList.push(key.value);
                            }
                        });

                        rootState[componentName].headers = header;

                        if (rootState[componentName].card.type != rootState[componentName].type._tree) {
                            totalFields = fieldsList.length;

                            //Auto arrange the field layout
                            if (rootState[componentName].multiColumn == 'Auto') {
                                if (totalFields >= 1 && totalFields <= 6) {
                                    rootState[componentName].card.multiColumn = 1;
                                } else if (totalFields >= 7 && totalFields <= 12) {
                                    rootState[componentName].card.multiColumn = 2;
                                } else if (totalFields >= 12 && totalFields <= 18) {
                                    rootState[componentName].card.multiColumn = 3;
                                } else {
                                    rootState[componentName].card.multiColumn = 4;
                                }

                                rootState[componentName].multiColumn = rootState[componentName].card.multiColumn;
                            } else {
                                rootState[componentName].card.multiColumn = rootState[componentName].multiColumn;
                            }

                            if (rootState[componentName].multiColumn > 2) {
                                rootState[componentName].landscape = false;
                            }

                            if (rootState[componentName].inlineEditor.enabled) {
                                rootState[componentName].landscape = false;
                            }
                        }
                    } else {
                        rootState[componentName].titleSearch = true;
                        let title = (payload.title[index]).substr(2).slice(0, -2);
                        rootState[componentName].headerTooltip = rootState[componentName].fields[title].title;
                    }
                });

                payload.renderComponent = false;

                Vue.nextTick(() => {
                    // @ts-ignore
                    payload.renderComponent = true;
                });
            }
        });
    }
}
